import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { BackendApiService } from 'src/app/service/backend-api.service';
import { BreadcrumbItem } from '../../shared/components/breadcrumb/breadcrumb.component';
import { Application } from 'src/app/model/application.model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PaginatedResponse } from 'src/app/interfaces/paginateResponse.interface';
import { AppelsService } from '../service/appels.service';
import { tap } from 'rxjs';
import { el } from 'date-fns/locale';
import { s } from '@fullcalendar/core/internal-common';
import { ca } from 'date-fns/locale';
import { MentoratService } from '../../mentorat/services/mentorat.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ApplicationSimplifyService } from '../../application-simplify/application-simplify.service';

@Component({
  selector: 'app-liste2appels',
  templateUrl: './liste2appels.component.html',
  styleUrls: ['./liste2appels.component.css'],
})
export class Liste2appelsComponent implements OnInit {
  public listApplicationParcours: any[] = [];
  public listApplicationsOffTrack: any[] = [];
  public listApplicationsWebinaire: any[] = [];
  public listApplicationsMentorat: any[] = [];
  public isLoading: boolean = true;
  public filterType: string = 'all';
  isDropdownOpen: boolean = false;
  showToggleConfirmModal: boolean = false;
  applicationToToggle: any | null = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  // Pagination pour les applications de parcours
  pageSizeParcoursApplications = 10;
  currentPageParcoursApplications = 0;
  totalElementsParcoursApplications = 0;
  paginatedResponseParcoursApplications: PaginatedResponse<Application> | null =
    null;

  // Pagination pour les applications hors parcours
  pageSizeOffTrackApplications = 10;
  currentPageOffTrackApplications = 0;
  totalElementsOffTrackApplications = 0;
  paginatedResponseOffTrackApplications: PaginatedResponse<Application> | null =
    null;

  // Pagination pour les applications mentorat
  pageSizeMentoratApplications = 10;
  currentPageMentoratApplications = 0;
  totalElementsMentoratApplications = 0;
  paginatedResponseMentoratApplications: PaginatedResponse<Application> | null =
    null;

  // Pagination pour les applications webinaire simplify
  pageSizeWebinaireApplication = 10;
  currentPageWebinaire = 0;
  totalElementsWebinaire = 0;
  paginatedResponseWebinaire: PaginatedResponse<Application> | null = null;

  // Pagination pour les applications parcours et hors parcours combinés
  currentPageAll = 0;
  pageSizeAll = 10;
  totalElementsAll = 0;
  paginatedResponseAll: PaginatedResponse<Application> | null = null;
  unifiedApplications: Application[] = [];
  pageSizeOptions: number[] = [10, 20, 30, 50, 100];

  dateActuel!: any;
  isAdmin: boolean = false;
  profil: any;
  user: any | null;
  role!: any;
  showToggleModal: boolean = false;
  appToToggle: any = null;
  isBeninGestionnaire: boolean = false;
  iuf: any;
  copiedAppId: number | null = null;
  constructor(
    private listApplications: BackendApiService,
    private appelsService: AppelsService,
    private mentoratService: MentoratService,
    private router: Router,
    private route: ActivatedRoute,
    private applicationSimplifyService: ApplicationSimplifyService
  ) { }

  ngOnInit(): void {
    this.user = sessionStorage.getItem('user');
    this.iuf = JSON.parse(this.user).iuf;
    this.profil = JSON.parse(this.user).profile.id;
    this.role = JSON.parse(this.user)?.roles;
    if (this.role.length > 0) {
      this.role.forEach((element: { id: number; roleName: any }) => {
        switch (element.roleName) {
          case 'admin': {
            this.isAdmin = true;
            break;
          }
          case 'gestionnaire-fcc-benin': {
            this.isBeninGestionnaire = true;
            break;
          }
        }
      });
    }
    if (this.isBeninGestionnaire) {
      this.filterType = 'horsParcours';
      this.loadOffTrackApplications();
      return;
    }
    this.loadParcoursApplications();
    this.loadOffTrackApplications();
    this.loadAllApplications();
    const typeFromQuery = this.route.snapshot.queryParamMap.get('type');
    this.filterApplications(typeFromQuery ?? this.filterType);
  }

  onUpdate(app: any): void {
    // On ne route vers le formulaire d'édition que pour les appels "parcours"
    // (adapte les routes des autres types si tu veux les gérer aussi)
    if (app.applicationType === 'parcours') {
      this.router.navigate(['/dashboard/appels/candidature', app.id]);
    } else if (app.applicationType === 'horsParcours') {
      this.router.navigate(['/dashboard/appels/candidatureHorsParcours', app.id]);
    } else if (app.applicationType === 'mentorat') {
      this.router.navigate(['/dashboard/appels/candidatureMentors', app.id]);
    } else if (app.applicationType === 'webinaire') {
      this.router.navigate(['/dashboard/application-simplify/candidaturewebinaire', app.id]);
    }
  }


  copyApplicationLink(app: any): void {
    const link: string | undefined = app?.applicationLink;
    if (!link) return;

    const onSuccess = () => {
      this.copiedAppId = app.id;
      setTimeout(() => {
        if (this.copiedAppId === app.id) this.copiedAppId = null;
      }, 2000);
    };

    // navigator.clipboard n'existe qu'en HTTPS ou localhost → fallback sinon
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(link).then(onSuccess).catch(() => this.fallbackCopy(link, onSuccess));
    } else {
      this.fallbackCopy(link, onSuccess);
    }
  }

  private fallbackCopy(text: string, onSuccess: () => void): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      if (document.execCommand('copy')) onSuccess();
    } catch (e) {
      console.error('Copie impossible :', e);
    } finally {
      document.body.removeChild(textarea);
    }
  }

  loadParcoursApplications(page: number = 0, size: number = 10): void {
    this.isLoading = true;
    this.listApplications
      .getApplicationsPaged(page, size)
      .pipe(
        tap((response: any) => {
          //console.log('Réponse des applications de parcours:', response);
          //console.log('Content response applications de parcours:', response.content);
          this.paginatedResponseParcoursApplications = response;
          if (response?.content) {
            this.listApplicationParcours = response.content.map((app: any) => {
              app.applicationStatus = this.calculStatus(app);
              app.applicationType = 'parcours';
              this.autoCorrectLaunch(app);
              return app;
            });
            this.currentPageParcoursApplications = response.number;
            this.pageSizeParcoursApplications = response.size;
            this.totalElementsParcoursApplications = response.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les applications de parcours',
            );
            this.listApplicationParcours = [];
          }
          this.isLoading = false;
        }),
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des applications de parcours:',
            error,
          );
          this.isLoading = false;
        },
      });
  }

  loadOffTrackApplications(page: number = 0, size: number = 10): void {
    this.isLoading = true;
    const request$ = this.isBeninGestionnaire
      ? this.appelsService.getApplicationOffTrackByPartnerPaged(this.iuf, page, size)
      : this.appelsService.getAllApplicationOffTrackPaged(page, size);
    request$
      .pipe(
        tap((response: any) => {
          this.paginatedResponseOffTrackApplications = response;
          if (response?.content) {
            this.listApplicationsOffTrack = response.content.map((app: any) => {
              app.applicationType = 'horsParcours';
              app.applicationStatus = this.calculStatus(app);

              const closeDate = this.parseDate(app.closeDate);
              const today = new Date();
              today.setHours(0, 0, 0, 0);

              if (closeDate && closeDate.getTime() < today.getTime()) {
                app.applicationLaunch = false;
              }

              return app;
            });
            this.currentPageOffTrackApplications = response.number;
            this.pageSizeOffTrackApplications = response.size;
            this.totalElementsOffTrackApplications = response.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les applications de parcours',
            );
            this.listApplicationsOffTrack = [];
          }
          this.isLoading = false;
        }),
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des applications de parcours:',
            error,
          );
          this.isLoading = false;
        },
      });
  }



  loadMentoratApplications(page: number = 0, size: number = 10): void {
    this.isLoading = true;
    this.mentoratService
      .getAllApplicationsMentoratPaginated(page, size)
      .pipe(
        tap((response: any) => {
          this.paginatedResponseMentoratApplications = response;
          if (response?.content) {
            this.listApplicationsMentorat = response.content.map((app: any) => {
              app.applicationStatus = this.calculStatus(app);
              app.applicationType = 'mentorat';
              this.autoCorrectLaunch(app);
              return app;
            });
            this.currentPageMentoratApplications = response.number;
            this.pageSizeMentoratApplications = response.size;
            this.totalElementsMentoratApplications = response.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les applications de parcours',
            );
            this.listApplicationsMentorat = [];
          }
          this.isLoading = false;
        }),
      )
      .subscribe({
        error: (error) => {
          console.error(
            'Erreur lors du chargement des applications de parcours:',
            error,
          );
          this.isLoading = false;
        },
      });
  }
  loadApplicationWebinaireSimplify(page: number = 0, size: number = 10): void {
    this.isLoading = true;
    this.appelsService
      .getAllApplicationWebinaireSimplifyPaginated(page, size)
      .pipe(
        tap((response: any) => {
          this.paginatedResponseWebinaire = response;
          // console.log('Application Webinaire:', response);
          if (response?.content) {
            this.listApplicationsWebinaire = response.content.map((app: any) => {

              app.applicationType = 'webinaire';

              app.applicationStatus = app.status;

              const closeDate = this.parseDate(app.closeDate);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              if (closeDate && closeDate.getTime() < today.getTime()) {
                app.applicationLaunch = false;
                app.applicationStatus = 'Terminé';
              }
              return app;
            });
            this.currentPageWebinaire = response.number;
            this.pageSizeWebinaireApplication = response.size;
            this.totalElementsWebinaire = response.totalElements;
          } else {
            this.listApplicationsWebinaire = [];
          }
          this.isLoading = false;
        }),
      )
      .subscribe({
        error: (error) => {
          console.error('Erreur chargement webinaires:', error);
          this.isLoading = false;
        },
      });
  }
  private calculStatusWebinaire(application: any): string {
    if (!application.openDate || !application.closeDate) {
      return 'En cours';
    }

    const now = new Date();
    // Les dates arrivent en string "yyyy-MM-dd" depuis @JsonFormat
    const openDate = new Date(application.openDate);
    const closeDate = new Date(application.closeDate);

    if (openDate > now) {
      return 'À venir';
    }

    if (closeDate >= now) {
      return 'En cours';
    }

    return 'Terminé';
  }

  loadAllApplications(page: number = 0, size: number = 10): void {
    this.isLoading = true;
    this.listApplications
      .getAllApplicationsPaged(page, size)
      .pipe(
        tap((response: any) => {
          //console.log('Réponse all applications:', response);
          //console.log('Content response all applications:', response.content);
          this.paginatedResponseAll = response;
          if (response?.content) {
            this.unifiedApplications = response.content.map((app: any) => {
              app.applicationStatus = this.calculStatus(app);
              return app;
            });
            this.currentPageAll = response.number;
            this.pageSizeAll = response.size;
            this.totalElementsAll = response.totalElements;
          } else {
            console.warn(
              'Response ou content est undefined pour les applications',
            );
            this.unifiedApplications = [];
          }
          this.isLoading = false;
        }),
      )
      .subscribe({
        error: (error) => {
          console.error('Erreur lors du chargement des applications:', error);
          this.isLoading = false;
        },
      });
  }

  calculStatus(application: Application): 'À venir' | 'En cours' | 'Terminé' {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const openDate = this.parseDate(application.openDate);
    const closeDate = this.parseDate(application.closeDate);

    if (openDate && openDate.getTime() > today.getTime()) {
      return 'À venir';
    }
    if (closeDate && closeDate.getTime() < today.getTime()) {
      return 'Terminé';
    }
    if (
      openDate &&
      closeDate &&
      openDate.getTime() <= today.getTime() &&
      closeDate.getTime() >= today.getTime()
    ) {
      return 'En cours';
    }
    return 'En cours';
  }

  private parseDate(
    dateValue: string | number | Date | null | undefined,
  ): Date | null {
    if (!dateValue) {
      return null;
    }

    let date: Date;

    if (dateValue instanceof Date) {
      date = new Date(dateValue);
    } else if (typeof dateValue === 'string') {
      date = new Date(dateValue);
    } else if (typeof dateValue === 'number') {
      const timestamp = dateValue < 10000000000 ? dateValue * 1000 : dateValue;
      date = new Date(timestamp);
    } else {
      return null;
    }
    if (isNaN(date.getTime())) {
      return null;
    }

    date.setHours(0, 0, 0, 0);
    return date;
  }

  private autoCorrectLaunch(app: any): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const openDate = this.parseDate(app.openDate);

    if (app.applicationStatus === 'Terminé') {
      app.applicationLaunch = false;
    } else if (app.applicationStatus === 'À venir') {
      app.applicationLaunch = false;
    } else if (openDate && openDate.getTime() === today.getTime()) {
      app.applicationLaunch = true;
    }
    // Sinon (En cours, mais pas le jour J) : on ne touche pas,
    // on respecte la valeur venant du backend (contrôle manuel de l'admin).
  }

  filterApplications(type: string): void {
    this.filterType = type;
    if (type === 'parcours' && this.listApplicationParcours.length === 0) {
      this.loadParcoursApplications(0, this.pageSizeParcoursApplications);
    } else if (
      type === 'horsParcours' &&
      this.listApplicationsOffTrack.length === 0
    ) {
      this.loadOffTrackApplications(0, this.pageSizeOffTrackApplications);
    } else if (
      type === 'webinaire' &&
      this.listApplicationsWebinaire.length === 0
    ) {
      this.loadApplicationWebinaireSimplify(
        0,
        this.pageSizeWebinaireApplication,
      );
    }
    switch (type) {
      case 'parcours':
        this.loadParcoursApplications(0, this.pageSizeParcoursApplications);
        break;
      case 'horsParcours':
        this.loadOffTrackApplications(0, this.pageSizeOffTrackApplications);
        break;
      case 'mentorat':
        this.loadMentoratApplications(0, this.pageSizeMentoratApplications);
        break;
      case 'all':
      default:
        this.loadAllApplications(0, this.pageSizeAll);
        break;
    }
  }

  onPageChange(event: PageEvent): void {
    if (this.filterType === 'parcours') {
      this.currentPageParcoursApplications = event.pageIndex;
      this.pageSizeParcoursApplications = event.pageSize;
      this.loadParcoursApplications(
        this.currentPageParcoursApplications,
        this.pageSizeParcoursApplications,
      );
    } else if (this.filterType === 'horsParcours') {
      this.currentPageOffTrackApplications = event.pageIndex;
      this.pageSizeOffTrackApplications = event.pageSize;
      this.loadOffTrackApplications(
        this.currentPageOffTrackApplications,
        this.pageSizeOffTrackApplications,
      );
    } else if (this.filterType === 'webinaire') {
      this.currentPageWebinaire = event.pageIndex;
      this.pageSizeWebinaireApplication = event.pageSize;
      this.loadApplicationWebinaireSimplify(
        this.currentPageWebinaire,
        this.pageSizeWebinaireApplication,
      );
    } else if (this.filterType === 'all') {
      this.currentPageAll = event.pageIndex;
      this.pageSizeAll = event.pageSize;
      this.loadAllApplications(this.currentPageAll, this.pageSizeAll);
    }
    switch (this.filterType) {
      case 'parcours':
        this.currentPageParcoursApplications = event.pageIndex;
        this.pageSizeParcoursApplications = event.pageSize;
        this.loadParcoursApplications(
          this.currentPageParcoursApplications,
          this.pageSizeParcoursApplications,
        );
        break;
      case 'horsParcours':
        this.currentPageOffTrackApplications = event.pageIndex;
        this.pageSizeOffTrackApplications = event.pageSize;
        this.loadOffTrackApplications(
          this.currentPageOffTrackApplications,
          this.pageSizeOffTrackApplications,
        );
        break;
      case 'mentorat':
        this.currentPageMentoratApplications = event.pageIndex;
        this.pageSizeMentoratApplications = event.pageSize;
        this.loadMentoratApplications(
          this.currentPageMentoratApplications,
          this.pageSizeMentoratApplications,
        );
        break;
      case 'all':
      default:
        this.currentPageAll = event.pageIndex;
        this.pageSizeAll = event.pageSize;
        this.loadAllApplications(this.currentPageAll, this.pageSizeAll);
        break;
    }
  }

  get applicationToDisplay(): any[] {
    switch (this.filterType) {
      case 'parcours':
        return this.listApplicationParcours;
      case 'horsParcours':
        return this.listApplicationsOffTrack;
      case 'webinaire':
        return this.listApplicationsWebinaire;
      case 'mentorat':
        return this.listApplicationsMentorat;
      case 'all':
      default:
        return this.unifiedApplications;
    }
  }

  get currentTotalElements(): number {
    switch (this.filterType) {
      case 'parcours':
        return this.totalElementsParcoursApplications;
      case 'horsParcours':
        return this.totalElementsOffTrackApplications;
      case 'webinaire':
        return this.totalElementsWebinaire;
      case 'mentorat':
        return this.totalElementsMentoratApplications;
      case 'all':
      default:
        return this.totalElementsAll;
    }
  }

  get currentPageSize(): number {
    switch (this.filterType) {
      case 'parcours':
        return this.pageSizeParcoursApplications;
      case 'horsParcours':
        return this.pageSizeOffTrackApplications;
      case 'webinaire':
        return this.pageSizeWebinaireApplication;
      case 'mentorat':
        return this.pageSizeMentoratApplications;
      case 'all':
      default:
        return this.pageSizeAll;
    }
  }

  get currentPageIndex(): number {
    switch (this.filterType) {
      case 'parcours':
        return this.currentPageParcoursApplications;
      case 'horsParcours':
        return this.currentPageOffTrackApplications;
      case 'webinaire':
        return this.currentPageWebinaire;
      case 'mentorat':
        return this.currentPageMentoratApplications;
      case 'all':
      default:
        return this.currentPageAll;
    }
  }

  // toggleLaunch(app: any): void {
  //     if (app.applicationType !== 'horsParcours') {
  //       return;
  //     }

  //     this.listApplications.toggleApplicationLaunch(app.id).subscribe({
  //       next: (response) => {
  //         app.applicationLaunch = response.applicationLaunch;
  //         app.applicationStatus = response.applicationStatus;
  //       },
  //       error: (error: any) => {
  //         console.error(
  //           "Erreur lors du changement d'état de l'application :",
  //           error,
  //         );
  //       },
  //     });
  //   }
  openToggleConfirm(app: any): void {
    if (
      app.applicationStatus === 'À venir' ||
      app.applicationStatus === 'Terminé'
    ) {
      return;
    }
    this.applicationToToggle = app;
    this.showToggleConfirmModal = true;
  }

  cancelToggle(): void {
    this.showToggleConfirmModal = false;
    this.applicationToToggle = null;
  }
  openToggleModal(app: any): void {
    this.appToToggle = app;
    this.showToggleModal = true;
  }

  closeToggleModal(): void {
    this.showToggleModal = false;
    this.appToToggle = null;
  }

  confirmToggleLaunch(): void {
    if (!this.appToToggle) return;
    this.toggleLaunch(this.appToToggle);
    this.closeToggleModal();
  }

  confirmToggle(): void {
    const app = this.applicationToToggle;
    this.showToggleConfirmModal = false;
    this.applicationToToggle = null;

    if (!app) {
      return;
    }

    if (app.applicationType === 'parcours') {
      this.listApplications.toggleApplication(app.id).subscribe({
        next: (updated: any) => {
          app.applicationLaunch = updated.applicationLaunch;
        },
        error: (err) => console.error('Erreur lors du toggle de l’application:', err),
      });
    } else if (app.applicationType === 'horsParcours') {
      this.listApplications.toggleApplicationLaunch(app.id).subscribe({
        next: (response: any) => {
          app.applicationLaunch = response.applicationLaunch;
          app.applicationStatus = response.applicationStatus;
        },
        error: (error: any) => console.error("Erreur lors du changement d'état :", error),
      });
    } else if (app.applicationType === 'mentorat') {
      this.mentoratService.toggleApplicationMentorat(app.id).subscribe({
        next: (updated: any) => {
          app.applicationLaunch = updated.applicationLaunch;
        },
        error: (err) => console.error('Erreur lors du toggle mentorat:', err),
      });
    }
  }


  onToggle(app: any): void {
    if (app.applicationType !== 'parcours') {
      return;
    }

    const action = app.applicationLaunch ? 'clôturer' : 'remettre en cours';
    const confirmed = window.confirm(
      `Voulez-vous vraiment ${action} cet appel "${app.applicationName}" ?`,
    );
    if (!confirmed) {
      return;
    }

    this.listApplications.toggleApplication(app.id).subscribe({
      next: (updated: any) => {
        app.applicationLaunch = updated.applicationLaunch;
      },
      error: (err) => {
        console.error('Erreur lors du toggle de l’application:', err);
      },
    });
  }
  copyLink(app: any): void {
    navigator.clipboard.writeText(app.applicationLink).then(() => {
      app.copied = true;
      setTimeout(() => (app.copied = false), 2000);
    });
  }
  editApplicationp(app: any): void {
    if (app.applicationType === 'parcours') {
      this.router.navigate([
        'dashboard/appels/candidature/',
        app.id
      ]);
    }
    if (app.applicationType === 'horsParcours') {
      this.router.navigate(['/dashboard/appels/editApplicationOffTrack', app.id]);
    } if (app.applicationType === 'webinaire') {
      this.router.navigate(['/dashboard/appels/editApplicationWebinaire', app.id]);
    }
    if (app.applicationType === 'mentorat') {
      this.router.navigate(['/dashboard/mentorat/candidatureMentors', app.id]);
    }


  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    { label: 'GESTION DES APPELS', url: '/dashboard/appels/listAppels' },
  ];

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }


  toggleLaunch(app: any): void {
    if (app.applicationType === 'horsParcours') {
      this.listApplications.toggleApplicationLaunch(app.id).subscribe({
        next: (response) => {
          app.applicationLaunch = response.applicationLaunch;
          app.applicationStatus = response.applicationStatus;
          //this.loadApplicationWebinaireSimplify()
        },
        error: (error: any) => {
          console.error('Erreur toggle horsParcours:', error);
        },
      });
    } else if (app.applicationType === 'webinaire') {
      this.applicationSimplifyService.toggleApplicationLaunchWebinaire(app.id).subscribe({

        next: (response) => {
          //Xconsole.log('Réponse du toggle webinaire:', response);
          app.applicationLaunch = response.applicationLaunch;
          app.applicationStatus = response.status;
        },
        error: (error: any) => {
          console.error('Erreur toggle webinaire:', error);
        },
      });
    }
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event): void {
    const dropdownElement = (event.target as HTMLElement).closest('.relative');
    if (!dropdownElement && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }
}
